export default __webpack_public_path__ + "static/media/jobPostPic.33e08a8b.svg";